'use client';

import { Search, CalendarCheck, Video, ArrowRight } from 'lucide-react';

const steps = [
  {
    number: '01',
    title: 'Encontre com confiança',
    description: 'Perfis verificados, avaliações reais e valores 100% transparentes.',
    icon: Search,
  },
  {
    number: '02',
    title: 'Agende sem complicação',
    description: 'Escolha o melhor dia ou horário e pague com segurança via PIX ou cartão.',
    icon: CalendarCheck,
  },
  {
    number: '03',
    title: 'Receba seu cuidado',
    description: 'Por teleconsulta ao vivo ou no conforto e privacidade do seu lar.',
    icon: Video,
  },
];

export function PatientJourney() {
  return (
    <section className="py-8 bg-muted/30 border-b border-border transition-colors">
      <div className="container-landing">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="flex items-center gap-4 p-4 rounded-2xl bg-card border border-border/70 shadow-xs relative"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0 font-extrabold text-base">
                  {step.number}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 mb-0.5">
                    <Icon className="w-3.5 h-3.5 text-primary" />
                    <p className="text-sm font-bold text-foreground truncate">{step.title}</p>
                  </div>
                  <p className="text-xs text-muted-foreground leading-relaxed">{step.description}</p>
                </div>

                {index < steps.length - 1 && (
                  <ArrowRight className="hidden md:block w-4 h-4 text-muted-foreground/40 absolute -right-6 top-1/2 -translate-y-1/2 z-10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
